module.exports = __webpack_public_path__ + "img/202.9b6a00c6.png";